import React from 'react';

import { range } from 'lodash';
import { ProgressBar, Step } from 'react-step-progress-bar';
import { concatClassNames } from '../../../utils/utilities';

import 'react-step-progress-bar/styles.css';
import classNames from './style.module.scss';

interface StepIndicatorProps {
	progress: number;
	totalSteps: number;
	activeStep: number;
}

interface StepItemProps {
	accomplished: boolean;
}

const StepIndicator: React.FC<StepIndicatorProps> = ({
	activeStep,
	totalSteps,
	progress,
}) => {
	return (
		<div className={classNames.stepContainer}>
			<ProgressBar percent={progress}>
				{range(1, totalSteps + 1).map((step) => (
					<Step key={step} transition="scale">
						{({ accomplished }: StepItemProps) => (
							<div
								className={concatClassNames([
									classNames.step,
									step === activeStep
										? classNames.stepActive
										: accomplished
										? classNames.stepAccomplished
										: '',
								])}
							>
								{step}
							</div>
						)}
					</Step>
				))}
			</ProgressBar>
		</div>
	);
};

export default StepIndicator;
